
import {spApi} from './sp'

export const spFindBusinessNameApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    spFindBusinessName: builder.mutation({
      
      query: ({payload}) => ({
        url: '/FindSpByBusinessName',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useSpFindBusinessNameMutation } = spFindBusinessNameApi